import TemplateView from '../../../../TemplateView'
import {escapeHtmlSymbols} from "../../../../atUtils";
import UserNameFormat from "../../../../util/UserNameFormat";
import $ from "jquery";
import EmptyHighlighter from "../../../../util/EmptyHighlighter";
import {getInstance as getTooltipInstance} from '../../../../SimpleSingletonTooltip'
import messageResource from '../../../../messageResource'

export default class NameCellContent extends TemplateView {
    constructor({
        warningsController = null,
        onClick = (e) => {},
        onMouseIn = (e) => {},
        onMouseOut = (e) => {},
    }) {
        super(null)

        this.state = {
            enabledInAp: false,
            enabled: false,
            firstName: '',
            lastName: '',
            middleInitial: '',
            username: '',
            userGroupName: '',
            timeZoneGroupName: '',
            infos: null,
            errors: null,
            warnings: null,
            withoutApprover: false,
            invalidReleaseDate: false,
            withoutWorkScope: false,
            highlighter: new EmptyHighlighter(),
            clickable: false,
            locked: false,
        }

        this.params = {
            onClick,
            warningsController,
            onMouseIn,
            onMouseOut,
        }

        this.onAnyStatePropertyChanged(['firstName', 'lastName', 'middleInitial', 'highlighter'], () => {
            this.find('.userNameSpan').html(UserNameFormat.formatLFM(
                this.hl(this.state.firstName),
                this.hl(this.state.lastName),
                this.hl(this.state.middleInitial),
            ))
        })

        this.onStatePropertyChanged('infos', () => this._updateInfo())

        this.onStatePropertyChanged('errors', () => this._updateErrors())

        this.onStatePropertyChanged('warnings', () => {
            if (this.state.warnings && this.state.warnings.length > 0) {
                this._createWarningsEl(this.find('.warningsInRow'), this.state.warnings);
            }
        })

        this.onAnyStatePropertyChanged(['userGroupName', 'timeZoneGroupName'], state => {
            this.find('.groupName').text(state.userGroupName)
            this.find('.timeZoneGroupName').text(state.timeZoneGroupName)

            const isDepartmentTmeZoneDisabled = !state.userGroupName.length && !state.timeZoneGroupName.length

            this.find('.userGroups').toggle(!isDepartmentTmeZoneDisabled)
            this.find('.userNameContainer').toggleClass('nameCellWithoutGroups', isDepartmentTmeZoneDisabled)
        })

        this.onStatePropertyChanged('withoutApprover', () => {
            this.$noApproverWarningIcon.toggleClass('hidden', !this.state.withoutApprover)
        })

        this.onStatePropertyChanged('invalidReleaseDate', () => {
            this.$invalidReleaseDateWarning.toggleClass('hidden', !this.state.invalidReleaseDate)
        })

        this.onStatePropertyChanged('withoutWorkScope', () => {
            this.$noWorkScopeWarningIcon.toggleClass('hidden', !this.state.withoutWorkScope)
        })

        this.onStatePropertyChanged('enabledInAp', (enabledInAp) => {
            this.find('userInOtherProduct').toggleClass('hidden', !enabledInAp)
        })

        this.onStatePropertyChanged('enabled', (enabled) => {
            this.find('inactive').toggleClass('hidden', !enabled)
        })

        this.onAnyStatePropertyChanged(['clickable', 'locked'], (state) => {
            this.$el.toggleClass('clickable', state.clickable && !state.locked)
        })
    }

    messageKeys() {
        return {
            inactiveText: 'userlist.inactive',
            enabledInApText: 'userlist.userdata.enabled_in_ap',
        }
    }

    templateHtml() {
        return '<div class="userNameContent">' +
               '    <table class="userNameContainer">' +
               '        <tr>' +
               '            <td>' +
               "                <div class='name'>" +
               "                    <span class='userInOtherProduct' title='<%=enabledInApText%>'></span>" +
               "                    <span class='userNameSpan'></span>" +
               "                    <span class='noApproverWarning'></span>" +
               "                    <span class='invalidReleaseDateWarning'></span>" +
               "                    <span class='inactive'><%=inactiveText%></span>" +
               "                    <span class='noWorkScopeWarning'></span>" +
               "                </div>" +
               "                <div class='userGroups'>" +
               "                    <div class='groupName'></div>" +
               "                    <div class='timeZoneGroupName'></div>" +
               "                </div>" +
               "                <div class='warningsInRow'></div>" +
               '            </td>' +
               '        </tr>' +
               '    </table>' +
               '</div>'

    }

    afterRender() {
        this.$noApproverWarningIcon = this.find('.noApproverWarning')
        this.$noWorkScopeWarningIcon = this.find('.noWorkScopeWarning')
        this.$invalidReleaseDateWarning = this.find('.invalidReleaseDateWarning')

        const tooltip = getTooltipInstance()
        tooltip.subscribeToMouseEvents(this.$noApproverWarningIcon, () => {
            tooltip.setState({
                html:  messageResource.getMessage('user_list.table.tooltip.no_approver', [escapeHtmlSymbols(this.state.firstName)]),
                extraClass: "userListNoApproversTooltip",
            })
        })
        tooltip.subscribeToMouseEvents(this.$noWorkScopeWarningIcon, () => {
            tooltip.setState({
                html:  messageResource.getMessage('userlist.work_assignments.table.tooltip.no_scope', [this.state.firstName]),
                extraClass: "userlist_workAssignmentsTab_noScopeTooltip",
            })
        })
        tooltip.subscribeToMouseEvents(this.$invalidReleaseDateWarning, () => {
            tooltip.setState({
                html:  messageResource.getMessage('user.add_edit.release_date_before_hire_date'),
                extraClass: "",
            })
        })

        this.$containerEl.on('click', (e) => this.params.onClick(e))
        this.$containerEl.hover((e) => this.params.onMouseIn(e), (e) => this.params.onMouseOut(e))
        this.renderInitialState()
    }

    _updateInfo() {
        if (this.$noteEl)
            this.$noteEl.remove()

        if (this.state.infos && this.state.infos.length > 0) {
            this.$noteEl = this._createNoteEl(this.state.username, 'infoSpan', this.state.infos)
            this.params.warningsController.setInfoHoverEvents(this.$noteEl, this.state.infos)
        }
    }

    _updateErrors() {
        if (this.$errorEl)
            this.$errorEl.remove()

        if (this.state.errors && this.state.errors.length > 0) {
            this.$errorEl = this._createErrorEl(this.state.username, 'errorSpan', this.state.errors)
            this.params.warningsController.setErrorsHoverEvents(this.$errorEl, this.state.errors)
        }
    }

    _createWarningsEl(warningSection, warnings) {
        if (!warnings) {
            warningSection.hide();
            return;
        }
        this.params.warningsController.setWarnings(warningSection, warnings)
    }

    _createNoteEl(username, className, notes) {
        let noteEl = document.createElement("span")
        noteEl.className = className
        noteEl.id = escapeHtmlSymbols(username) + '_className'

        let noteJQEl = $(noteEl)
        this.params.warningsController.setClickEvents(noteJQEl, notes)
        this.find(".userNameSpan").after(noteJQEl)
        return noteJQEl
    }

    _createErrorEl(username, className, errors) {
        let errorEl = document.createElement("span")
        errorEl.className = className
        errorEl.id = escapeHtmlSymbols(username) + '_className'

        let errorJQEl = $(errorEl)
        this.params.warningsController.setClickEvents(errorJQEl, errors)
        this.find(".userNameSpan").after(errorJQEl)
        return errorJQEl
    }

    hl(str) {
        return this.state.highlighter.highlightTokens(str);
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/NameCellContent.js